import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/contact-visibility'),
      component: SettingsContent,
      props: {
        headerTitle: 'Contact Visibility',
        icon: 'eye-hide',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_contact_visibility',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
